/**
 * file : MyTournament/Index.jsx
 * 설명 : 나의 토너먼트 메인 화면
 */

import banner_img4 from "assets/images/banner_img4.jpg";
import banner_img5 from "assets/images/banner_img5.jpg";
import banner_img6 from "assets/images/banner_img6.jpg";

import { Link } from 'react-router-dom';
import { useState } from 'react';
import TournamentList from "pages/TournamentRelated/List"
import { Spinner } from "components/Common/Componentization";

export default function Index() {

  document.title = "나의 토너먼트"
  // 데이터 로딩
  const [dataLoading, setDataLoading] = useState(false);

  return (
    <>
      <Spinner show={dataLoading} />
      <div className="container_sub">
        <div className="location">
          전체 토너먼트 &nbsp; &gt; &nbsp; 나의 토너먼트
        </div>
        {/* =================== 사용 미정 =================== */}
        <div className="sub_banner" style={{ display: 'none' }}>
          <div className="big_banner">
            <Link href="#"><img src={banner_img4} alt="banner_img4" /></Link>
          </div>
          <div className="second_banner box_style4">
            <ul>
              <li><Link href="#"> <img src={banner_img5} alt="banner_img5" /> </Link></li>
              <li><Link href="#"> <img src={banner_img6} alt="banner_img6" /> </Link></li>
            </ul>
          </div>
        </div>
        <TournamentList type="M" setDataLoading={setDataLoading} />
      </div>
    </>
  )
}